import { window } from "global";
import React, { useState, useEffect, useRef, useContext } from "react";
import classnames from "classnames";
import { useLocation } from "react-router-dom";
import { getSummonerProfileContext } from "components/SummonerProfiles/SummonerProfileContext";
import RankBlock from "components/SummonerProfiles/views/ProfileOverview/Rank/RankBlock";
import PlayedChampionsContainer from "components/SummonerProfiles/views/ProfileOverview/PlayedChampions/PlayedChampionsContainer";
import MatchBlock from "components/SummonerProfiles/views/ProfileOverview/MatchHistory/MatchBlock";
import RecentlyPlayedWith from "components/SummonerProfiles/views/ProfileOverview/RecentlyPlayedWith/RecentlyPlayedWith";
import Profile200kModal from "./Profile200kModal";
import TwoMonthFreeBoostPopup from "components/Popups/TwoMonthFreeBoostPopup";
import { logUpdateProfile } from "./overview-logging";
import { UpdateDispatchContext } from "components/SummonerProfiles/SummonerProfileUpdateReducer";

const SummonerProfileOverview = (props) => {
  // const [loadPopup, setLoadPopup] = useState(false);
  const location = useLocation();
  const dispatch = useContext(UpdateDispatchContext);
  const context = getSummonerProfileContext();
  const { summonerName, region, userSummonerName, isSameSummoner, premium, userVerified, previewMode } = context;
  const { profileInit, setProfileModalState } = props;
  const [currentProfile, setCurrentProfile] = useState({ summonerName, region });
  const [refetchedMatches, setRefetchedMatches] = useState(null);
  const [refetchedLP, setRefetchedLP] = useState(null);
  const [matchSummariesRPW, setMatchSummariesRPW] = useState();

  // const [overviewFilters, setOverviewFilters] = useState(defaultOverviewFilters);
  // const useFilterCategoryState = useFilters(overviewFilters, setOverviewFilters);
  // console.log("overviewFilters", overviewFilters);

  const onUpdateCompleted = (data) => {
    const { matchSummary, lp1, lp2, lp3 } = data || {};
    const { fetchPlayerMatchSummaries } = (matchSummary && matchSummary.data) || {};
    const { matchSummaries } = fetchPlayerMatchSummaries || {};
    setRefetchedMatches(matchSummaries);
    setRefetchedLP([lp3 && lp3.data, lp2 && lp2.data, lp1 && lp1.data]);
    logUpdateProfile(data);
  };
  const onUpdateError = (error) => {
    // console.log("on update error", error)
  };

  useEffect(() => {
    if (location.state && location.state.scrollTop) {
      window.scrollTo(0, 0);
    }
    dispatch({ type: "onCompleted", payload: onUpdateCompleted });
    dispatch({ type: "onError", payload: onUpdateError });
    // setTimeout(()=> {setLoadPopup(true)}, 5000)
  }, []);

  // Reset update and matches on profile change
  useEffect(() => {
    // setOverviewFilters(defaultOverviewFilters);
    setRefetchedMatches(null);
    setRefetchedLP(null);
    setCurrentProfile({ summonerName, region });
  }, [summonerName, region]);

  const hadBgSet = profileInit && profileInit.customizationData && profileInit.customizationData.headerBg === "";
  let popUpState = !userSummonerName
    ? "logged-out"
    : !userVerified
    ? "unverified"
    : !premium
    ? "not-premium"
    : hadBgSet
    ? "not-premium"
    : ""; // last state should probably be custom-profile when all users no longer have premium.
  popUpState = isSameSummoner || !userSummonerName ? popUpState : "";

  const loadingPage = false; //window && loading;
  const summonerProfileOverviewClassNames = classnames("summoner-profile_overview2", {
    "summoner-profile_overview_loading": loadingPage,
  });

  return (
    <div className={summonerProfileOverviewClassNames}>
      {/*!previewMode && (
        <Profile200kModal
          modalState={popUpState}
          setProfileModalState={setProfileModalState}
        />
      )*/}
      {/* {!previewMode && loadPopup && popUpState !== "logged-out" && ((premium && !premium.isPremium) || !premium) && <TwoMonthFreeBoostPopup/>} */}
      {loadingPage ? (
        <div className="spinthatshit-loader">
          <div className="spinner" />
        </div>
      ) : (
        <React.Fragment>
          <div className="summoner-profile_overview__side">
            <RankBlock refetchedLP={refetchedLP} />
            <PlayedChampionsContainer />
            <RecentlyPlayedWith matchSummariesRPW={matchSummariesRPW} />
          </div>
          <div className="summoner-profile_overview__main">
            <MatchBlock refetchedMatches={refetchedMatches} setMatchSummariesRPW={setMatchSummariesRPW} />
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default SummonerProfileOverview;
